document.querySelector("#masonry").addEventListener("click", (event) => {
  if (document.fullscreenElement) {
    document.exitFullscreen();
    return;
  }
  if (event.target.tagName !== "IMG") {
    return;
  }
  event.target.requestFullscreen();
});
